<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    class="mode new_mode"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="商品明細選択"
    top="5vh"
    :visible.sync="dialogVisible"
    :show-close="false"
    append-to-body
    @opened="opened"
    @close="overrideClose"
  >
    <vab-query-form-mode
      :model="queryForm"
      :rules="rules"
      class="dpform noborder nopadding"
      :enable-query-save="false"
      size="mini"
      label-position="left"
      label-width="98px"
      @search="onSearch"
    >
      <el-row :gutter="24" class="row_mb27">
        <el-col :span="8">
          <vab-input prop="itmdtlcd" label="商品明細CD" maxlength="3" />
        </el-col>
        <el-col :span="8">
          <vab-input
            prop="itmdtlnmk"
            label="商品明細名"
            maxlength="50"
            show-after="半角ｶﾅ"
            validate="halfKana"
            class="mb16"
          />
        </el-col>
      </el-row>
    </vab-query-form-mode>
    <el-row class="mt16 nomargin_w">
      <el-col :span="24">
        <vab-table
          ref="table"
          :api-url="
            apiJudge
              ? `/api/mitmdtlp/queryItemDetail`
              : `/api/mitmdtlp/queryItemDetailGroup`
          "
          :columns="columns"
          :custom-config="false"
          :multi-select="multiSelect"
          :query-params="{
            ...queryForm,
            sidx: 'itmdtlcd',
            sort: 'asc',
          }"
          :init-params="{
            ...queryForm,
            sidx: 'itmdtlcd',
            sort: 'asc',
          }"
          primary-key="itmdtlcd"
          primary-key-sort="asc"
          :row-key="getRowKey"
          :enable-init="false"
          @selection-change="setSelectRows"
        />
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer flex_end">
      <div class="flex_start flex_center_align">
        <el-button class="cancel" @click="overrideClose">キャンセル</el-button>
        <el-button
          type="primary"
          :disabled="selectRows.length == 0"
          class="sub_btn select_btn"
          @click="save()"
        >
          <svg-icon
            class="sub_btn_svg"
            icon-class="check_line"
            :class="selectRows.length == 0 ? 'answer_disabled' : 'answer'"
          ></svg-icon>
          確定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import mixDialog from '@/utils/mixDialog'
  export default {
    name: 'MitmdtlpDialogNew',
    mixins: [mixDialog],
    props: {
      goodslists: {
        type: Array,
        default: () => [],
      },
      apiJudge: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        queryForm: {
          itmcd: null,
          itmdtlcd: null,
          itmdtlnmk: null,
          //商品コードリスト
          itmcdList: null,
        },
        columns: [
          {
            label: '商品明細CD',
            'min-width': 120,
            prop: 'itmdtlcd',
          },
          {
            label: '商品明細名',
            'min-width': 160,
            prop: 'itmdtlnm',
          },
          {
            label: '商品明細名（半角ｶﾅ）',
            'min-width': 180,
            prop: 'itmdtlnmk',
          },
          {
            label: '課税フラグ',
            'min-width': 120,
            prop: 'taxntxf',
          },
          {
            label: '税率',
            'min-width': 120,
            prop: 'taxrt',
          },
        ],
      }
    },

    methods: {
      getRowKey(row) {
        return row.itmcd + '-' + row.itmdtlcd
      },

      overrideClose() {
        this.$refs.itemCdList?.reset()
        this.close()
      },
    },
  }
</script>
<style lang="scss" scoped>
  .select_btn {
    background: #0060c2;
    border: 1px solid #0060c2;
    color: #ffffff;
    &:hover {
      background: #0171ee;
      border: 1px solid #0171ee;
    }
  }
</style>
